// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__dasUp","signOut":"SideBar_signOut__v1qyS"};